import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import "src/App.css";
import { FirebaseAuthProvider } from "src/contexts/FirebaseAuthContext";
import { SnackbarProvider } from "src/contexts/SnackbarContext";
import AppRoutes from "src/routes";
import theme from "src/theme";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { store } from "src/store";
import { HelmetProvider } from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";

function App() {
  return (
    <HelmetProvider>
      <ReduxProvider store={store}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SnackbarProvider>
              <FirebaseAuthProvider>
                <AppRoutes />
              </FirebaseAuthProvider>
            </SnackbarProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </ReduxProvider>
    </HelmetProvider>
  );
}

export default App;
